var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_11167_64199)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11167_64199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.36364 20.5001H8.54545V12.7729L4 9.36377V19.1365C4 19.891 4.61136 20.5001 5.36364 20.5001Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4551 20.5001H22.6369C23.3914 20.5001 24.0005 19.8888 24.0005 19.1365V9.36377L19.4551 12.7729",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4551 6.8636V12.7727L24.0005 9.3636V7.54542C24.0005 5.85905 22.0755 4.89769 20.7278 5.90905",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54492 12.7729V6.86377L13.9995 10.9547L19.454 6.86377V12.7729L13.9995 16.8638",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.54542V9.3636L8.54545 12.7727V6.8636L7.27273 5.90905C5.92273 4.89769 4 5.85905 4 7.54542Z",
    fill: "#C5221F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_11167_64199",
    x: 0.2,
    y: 5.96046e-8,
    width: 27.6,
    height: 27.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11167_64199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.225
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_11167_64199",
    result: "effect2_dropShadow_11167_64199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_11167_64199",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11167_64199"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white",
    transform: "translate(4 5.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.89ca140ae5e1afb8120dfabe5f342df3.svg";
export { ForwardRef as ReactComponent };